// extracted by mini-css-extract-plugin
module.exports = {"passwordForm":"styles_passwordForm__3otnM","spinner":"styles_spinner__2eJn_"};